import {getCookie, showModalCookies} from "../../webpack/modules-optimized/cookies";

let cookieChoice = getCookie('_tv_cookie_choice');
let cookieCountry = sessionStorage.getItem('_tv_user_cookie_country') === 'true';

if (!cookieChoice && cookieCountry) showModalCookies();
